module.exports = __webpack_public_path__ + "img/xianmi5kg.eeb3fda4.jpg";